import {Directive, forwardRef, Input} from '@angular/core';
import {FormControl, NG_VALIDATORS, Validator} from '@angular/forms';
import {IbanValidationService} from '../services/ibanValidation.service';

@Directive({
    providers: [
        {
            multi: true,
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => KontoValidatorDirective),
        },
    ],
    selector: '[lvIbanValidator]',
    standalone: false
})
export class KontoValidatorDirective implements Validator {
  constructor(private _ibanValidationService: IbanValidationService) {
  }

  public validate(control: FormControl): {} {
    if (!control || !control.value) {
      return null;
    }
    const valueWithoutBlanks = control.value.replace(/\s/g, '').toUpperCase(); // ersetze alle blanks
    const validationResult = this._ibanValidationService.validatePartialIban(valueWithoutBlanks, false);
    if (validationResult) {
      return {PARTIAL: validationResult.error, VIOLATION: validationResult.format};
    }
    if (valueWithoutBlanks.length > 2 && !this._ibanValidationService.validateIban(valueWithoutBlanks)) {
      return {ERROR: 'WRONG'};
    }
    return null;
  }

}
